import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import io from 'socket.io-client';
import API_HOST from '../../shared/utils/ApiHost.js';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useFormik } from 'formik';
import * as yup from 'yup';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'© '}{new Date().getFullYear()}
      <Link color="inherit" href="https://mintmadness.app">
        Mint Madness
      </Link>{' '}
    </Typography>
  );
}

const validationSchema = yup.object({
  email: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string('Enter your password')
    .min(8, 'Password should be of minimum 8 characters length')
    .required('Password is required')
});


export default function SignIn() {
  const [isAuthenticated, setAuthenticated] = useState(false)
  const [authIncorrect, setAuthIncorrect] = useState(false)
  const [cookies, setCookie] = useCookies(['room']);

  const group = localStorage.getItem('groupId') !== null ? localStorage.getItem('groupId') : ''

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      group: group
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      var sendValues = JSON.stringify(values, null, 2);
      fetch(`${API_HOST}/api/login`,{
          method: 'post',
          headers: { 'Content-Type': 'application/json'},
          credentials: 'include',
          body: sendValues
      }).then(res=>res.json())
      .then(data=>{

        console.log(data)
        if(data.status === 'success') {
          var duration = 60 * 60 * 24 * 5; // 5 days
          localStorage.setItem('username',data.username)
          
          if(typeof data.room !== 'undefined' && data.room !== '') {
            setCookie('room', data.room, { path: '/' , maxAge: duration});
            console.log(cookies.room)
            localStorage.setItem('room',data.room)
            localStorage.setItem('groupId',data.room)
            localStorage.setItem('teamId',data.teamId)
            localStorage.setItem('admin',data.admin)
            const socket = io(API_HOST,{
              withCredentials: true,
              extraHeaders: {
                  "room": cookies.room
              }
            });
            console.log('try to connect to socket')
            socket.on("connected", data => {
              console.log(data)     
            });
          }
          setAuthenticated(true)
        } else {
          if(data.message === 'auth error') {
            setAuthIncorrect(true)
          }
        }
        
      })
      .catch(e=>{
        console.error(e)
        setAuthIncorrect(true)
      })
    }
  });

  if(isAuthenticated) {
    return <Redirect to="/draft" />
  }

  return (
    <Container maxWidth="xs" className="form-container">
      <CssBaseline />
      <div className="form-wrapper"> 
        <div style={{textAlign: 'center'}}><img src="//mintconditioned.com/mintmadnessdraft/images/mint-madness-logo.svg" alt="Mint Madness" width="240" style={{height: 'auto', display: 'inline-block'}} /></div>

        <Typography component="h1" variant="h3">
          Sign in
        </Typography>
        {authIncorrect &&
          <p className="warning-message">The email or password do not match. Please try again.</p>
        }
        <form className="form form__user form__join" noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                variant="outlined"
                required
                fullWidth
                type="email"
                id="email"
                label="Email Address"
                error={formik.touched.email && Boolean(formik.errors.email)}
                value={formik.values.email}
                onChange={formik.handleChange}
                name="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                minLength="8"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className="form-submit"
          >
            Sign In
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="/join" variant="body2" className="signin-login-link">
                Don&rsquo;t have an account? Sign up
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container> 
  );
}